import React from "react";

import { Button } from "~/components/button";
import { SystemScreen } from "~/components/system-screen";

import { TRIAL_LINK } from "../../docLink/AllDocLinkSlugs";
import { Link } from "../../link/Link";

export const TrialExpired: React.FC = () => (
	<SystemScreen alertContent="Your subscription has expired!" alertVariant="error" className="min-h-full">
		<p className="mb-10">
			Please get in touch with us to resume using your trial instance and one of our experts will reach back to you.
		</p>
		<Link el="a" href={TRIAL_LINK} target="_blank">
			<Button className="uppercase" variant="primary">
				Contact us
			</Button>
		</Link>
	</SystemScreen>
);
